import logo from './logo.svg';
import './App.css';
import ProjectList from './Projectlist';

function App() {
  return (
    <div className="App">
     <ProjectList />  
    </div>
  );
}

export default App;
